import { Box } from 'braid-design-system';
import striptags from 'striptags';
import * as styles from './JobListItemView.css';

export const getJobDataAutomation = (
  isPremium: boolean,
  locationMatch?: 'Exact',
) => {
  if (isPremium) {
    return 'premiumJob';
  }

  if (locationMatch === 'Exact') {
    return 'tier1job';
  }

  return 'normalJob';
};

export const parseHTML = (text: string, tag: HTMLElement['tagName']) => {
  const regex = RegExp(`<${tag}>(.*?)<\/${tag}>`);

  return text
    .split(regex)
    .reduce<Array<{ text: string; highlight: boolean }>>(
      (result, txt, index) => {
        if (txt !== '') {
          result.push({
            text: txt,
            highlight: index % 2 === 1,
          });
        }
        return result;
      },
      [],
    );
};

export const highlightFromHTML = ({
  html,
  isDescription = false,
}: {
  html: string;
  isDescription?: boolean;
}) =>
  parseHTML(html, 'b').map(({ highlight, text }, index) => {
    const cleanText = striptags(text);

    return highlight ? (
      <Box
        component="mark"
        key={index}
        data-automation="jobItem-highlight"
        className={[
          styles.parseHTML,
          {
            [styles.parseHTML_isDescription]: isDescription,
          },
        ]}
      >
        {cleanText}
      </Box>
    ) : (
      cleanText
    );
  });
